import classNames from 'classnames/bind';
import React from 'react';

import styles from './common.module.scss';

import { FieldNumber } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  return (
    <div className={cx('container')}>
      <label>
        Latitude
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.position.lat.toFixed(7)} readOnly />
          <span className={cx('unit')} />
        </div>
      </label>
      <label>
        Longitude
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.position.lng.toFixed(7)} readOnly />
          <span className={cx('unit')} />
        </div>
      </label>
      <label>
        Relative Altitude
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.altitude.toFixed(1)} readOnly />
          <span className={cx('unit')}>m</span>
        </div>
      </label>
      <label>
        Turns
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.turns} readOnly />
          <span className={cx('unit')} />
        </div>
      </label>
    </div>
  );
};

export default Item;
